import { green, orange, red } from 'bold-ui/lib/styles/colors'
import { SimNaoEnum } from 'components/form'
import { MChat, MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'

export const MCHAT_URL_MODAL = '/mchat'

export type MChatQueryModel = Pick<MChat, 'risco' | 'pontuacao' | 'aplicacao' | 'dataResultado'>

export type MChatAplicacaoModel = Record<MChatPerguntaEnum, SimNaoEnum>

export interface MChatFieldModel {
  aplicacao: MChatAplicacaoModel
  resultado: number
  risco: MChatRiscoEnum
}

export type MChatAnteriorFooterInfoModel = {
  lotacao: {
    profissional: { nome: string; nomeSocial?: string }
    cbo: { nome: string }
  }
  dataResultado: LocalDate
  atendimentoProfissionalId: ID
}

interface MChatResultadoModel {
  textColor: string
  lineColor: string
  backgroundColor: string
  shortTitle: string
  encaminhamento: (idadeEmMeses: number) => string
}

export const MCHAT_PERGUNTAS: Partial<Record<MChatPerguntaEnum, string>> = {
  PERGUNTA_01:
    'Se você apontar para algum objeto no quarto, o seu filho olha para este objeto? (POR EXEMPLO, se você apontar para um brinquedo ou animal, o seu filho olha para o brinquedo ou para o animal?)',
  PERGUNTA_02: 'Alguma vez você se perguntou se o seu filho pode ser surdo?',
  PERGUNTA_03:
    'O seu filho brinca de faz de contas? (POR EXEMPLO, faz de conta que bebe em um copo vazio, faz de conta que fala ao telefone, faz de conta que dá comida a uma boneca ou a um bichinho de pelúcia?)',
  PERGUNTA_04: 'O seu filho gosta de subir nas coisas? (POR EXEMPLO, móveis, brinquedos em parques ou escadas)',
  PERGUNTA_05:
    'O seu filho faz movimentos estranhos com os dedos perto dos olhos? (POR EXEMPLO, mexe os dedos em frente aos olhos e fica olhando para os mesmos?)',
  PERGUNTA_06:
    'O seu filho aponta com o dedo para pedir algo ou para conseguir ajuda? (POR EXEMPLO, aponta para um biscoito ou brinquedo fora do alcance dele?)',
  PERGUNTA_07:
    'O seu filho aponta com o dedo para mostrar algo interessante para você? (POR EXEMPLO, aponta para um avião no céu ou um caminhão grande na rua)',
  PERGUNTA_08:
    'O seu filho se interessa por outras crianças? (POR EXEMPLO, seu filho olha para outras crianças, sorri para elas ou se aproxima delas?)',
  PERGUNTA_09:
    'O seu filho traz coisas para mostrar para você ou as segura para que você as veja - não para conseguir ajuda, mas apenas para compartilhar? (POR EXEMPLO, para mostrar uma flor, um bichinho de pelúcia ou um caminhão de brinquedo)',
  PERGUNTA_10:
    'O seu filho responde quando você o chama pelo nome? (POR EXEMPLO, ele olha para você, fala ou emite algum som, ou para o que está fazendo quando você o chama pelo nome?)',
  PERGUNTA_11: 'Quando você sorri para o seu filho, ele sorri de volta para você?',
  PERGUNTA_12:
    'O seu filho fica muito incomodado com barulhos do dia a dia? (POR EXEMPLO, seu filho grita ou chora ao ouvir barulhos como os de liquidificador ou de música alta?)',
  PERGUNTA_13: 'O seu filho anda?',
  PERGUNTA_14:
    'O seu filho olha nos seus olhos quando você está falando ou brincando com ele/ela, ou vestindo a roupa dele/dela?',
  PERGUNTA_15:
    'O seu filho tenta imitar o que você faz? (POR EXEMPLO, quando você dá tchau, ou bate palmas, ou joga um beijo, ele repete o que você faz?)',
  PERGUNTA_16:
    'Quando você vira a cabeça para olhar para alguma coisa, o seu filho olha ao redor para ver o que você está olhando?',
  PERGUNTA_17:
    'O seu filho tenta fazer você olhar para ele/ela? (POR EXEMPLO, o seu filho olha para você para ser elogiado/aplaudido, ou diz: “olha mãe!” ou “óh mãe!”)',
  PERGUNTA_18:
    'O seu filho compreende quando você pede para ele/ela fazer alguma coisa? (POR EXEMPLO, se você não apontar, o seu filho entende quando você pede: “coloca o copo na mesa” ou “liga a televisão”)?',
  PERGUNTA_19:
    'Quando acontece algo novo, o seu filho olha para o seu rosto para ver como você se sente sobre o que aconteceu? (POR EXEMPLO, se ele/ela ouve um barulho estranho ou vê algo engraçado, ou vê um brinquedo novo, será que ele/ela olharia para seu rosto?)',
  PERGUNTA_20: 'O seu filho gosta de atividades de movimento? (POR EXEMPLO, ser balançado ou pular em seus joelhos).',
}

export const MCHAT_RESULTADOS: Record<MChatRiscoEnum, MChatResultadoModel> = {
  BAIXO: {
    textColor: green.c40,
    lineColor: green.c60,
    backgroundColor: green.c90,
    shortTitle: 'baixo',
    encaminhamento: (idadeEmMeses: number) => {
      if (idadeEmMeses < 24) {
        return '<strong>Se a criança tem menos de 24 meses, reavaliar após aniversário de dois anos.</strong> Se houver suspeita pela família ou profissional, o M-CHAT-R deverá ser reaplicado, mesmo que o resultado seja de baixo risco.'
      }
      return 'Se houver suspeita pela família ou profissional, o M-CHAT-R deverá ser reaplicado, mesmo que o resultado seja de baixo risco.'
    },
  },
  MEDIO: {
    textColor: orange.c40,
    lineColor: orange.c60,
    backgroundColor: orange.c90,
    shortTitle: 'médio',
    encaminhamento: () =>
      '<strong>Aplicar Entrevista de seguimento para obter informações adicionais sobre as respostas de risco, evitando falso positivo.</strong>',
  },
  ELEVADO: {
    textColor: red.c40,
    lineColor: red.c60,
    backgroundColor: red.c90,
    shortTitle: 'elevado',
    encaminhamento: () =>
      '<strong>Não é necessário fazer a Entrevista de seguimento, a criança deve ser encaminhada imediatamente para avaliação diagnóstica e intervenção precoce.</strong> É necessário acionar as equipes multiprofissionais e/ou atenção especializada.',
  },
}
